<template>
  <div class="row">
    <div class="position-relative form-group col-12 pl-0 pr-0 d-flex flex-wrap">
      <label class="col-12">Token*</label>
      <div class="input-group col-6 pr-2">
        <input name="token" type="text" class="form-control" placeholder="Token Id" :value="data.token.id" @change.stop.prevent="store.commit('token.id', $event.target.value)" />
      </div>
      <div class="input-group col-6 pl-2">
        <input name="token" type="text" class="form-control" placeholder="Token Secret" :value="data.token.secret" @change.stop.prevent="store.commit('token.secret', $event.target.value)" />
      </div>
    </div>
    <div class="position-relative form-group col-12">
      <label class="col-12 mb-0 p-0">Callback URL*</label>
      <input class="form-control mt-2" type="text" :value="data.meta.callback_url" @change.stop.prevent="store.commit('meta.callback_url', $event.target.value)" />
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {}
  },
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    tokenId() {
      return this.config?.tokenId
    },
    data() {
      return this.store.getter('', {
        token: {
          id: '',
          secret: ''
        },
        meta: {
          callback_url: ''
        }
      })
    }
  },
  methods: {},
  props: {
    config: Object
  }
}
</script>
